export var IMAGE_WIDTH = 720;
export var IMAGE_HEIGHT = 80;
//# sourceMappingURL=ImageReductionSizes.js.map